/// <reference path="../Page.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class ResultListPage extends Page {

    }

}
